import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = { interval: Number }

  connect() {
    this.currentSlideIndex = 1
    this.updateActiveIndicator()
    if (this.hasSlideTarget && this.intervalValue > 0) {
      this.startAutoRotation()
    }
  }

  disconnect() {
    this.stopAutoRotation()
  }

  startAutoRotation() {
    this.autoRotationTimer = setInterval(() => {
      this.nextSlide()
    }, this.intervalValue)
  }

  stopAutoRotation() {
    if (this.autoRotationTimer) {
      clearInterval(this.autoRotationTimer)
    }
  }

  nextSlide() {
    this.showSlide(this.getNextSlideIndex())
  }

  prevSlide() {
    this.showSlide(this.getPrevSlideIndex())
  }

  goToSlide(event) {
    const index = parseInt(event.currentTarget.dataset.carouselIndexParam)
    this.showSlide(index)
  }

  showSlide(index) {
    // Hide all slides
    this.slideTargets.forEach(slide => {
      slide.classList.add('hidden')
      slide.classList.remove('block')
    })

    // Show the selected slide
    const slideToShow = this.slideTargets[index - 1]
    if (slideToShow) {
      slideToShow.classList.remove('hidden')
      slideToShow.classList.add('block')
      this.currentSlideIndex = index
      this.updateActiveIndicator()
    }

    // Reset the auto-rotation timer
    this.resetAutoRotation()
  }

  resetAutoRotation() {
    if (this.intervalValue > 0) {
      this.stopAutoRotation()
      this.startAutoRotation()
    }
  }

  updateActiveIndicator() {
    if (this.hasIndicatorTarget) {
      this.indicatorTargets.forEach((indicator, index) => {
        if (index + 1 === this.currentSlideIndex) {
          indicator.classList.add('btn-primary')
        } else {
          indicator.classList.remove('btn-primary')
        }
      })
    }
  }

  getNextSlideIndex() {
    return this.currentSlideIndex >= this.slideTargets.length ? 1 : this.currentSlideIndex + 1
  }

  getPrevSlideIndex() {
    return this.currentSlideIndex <= 1 ? this.slideTargets.length : this.currentSlideIndex - 1
  }
} 